import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {
  "published": false
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`In this series, I hope to build intuition and understanding of machine learning topics leading up to modern neural networks, below is the plan for the series and links to completed posts.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/blog/neural-net-gradient-descent/"
        }}>{`Gradient Descent`}</a></li>
      <li parentName="ul">{`Logistic Regression for Classification`}</li>
      <li parentName="ul">{`Two Layer Neural Network`}</li>
      <li parentName="ul">{`Gradients Over Many Layers`}</li>
      <li parentName="ul">{`Modern Deep Learning Frameworks`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      